import React from "react";
import test from './../assets/termsConditions.webp';
import config from "../config/config";
import SEO from "../seo/SEO";
import { Link } from 'react-router-dom';

const ShippingAndReturns = () => {
  return (
    <>
          <SEO
              robots="noindex, follow"
              title="Shipping & Returns - Withrow Knives"
              description="Learn about Withrow Knives' shipping policies, returns, and our lifetime guarantee on handmade knives."
              url={`${config.metadata.siteUrl}/shipping-returns`}
          />


          <div className="page-wrapper">
            <div
              className="page-title"
              style={{
                backgroundImage: `url(${test})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <h1>Shipping & Returns</h1>
              <p className="page-subtitle">Last updated March 27, 2025.</p>
            </div>

            <div className="page-content-section terms-content">

              <section aria-labelledby="shipping-info">
                <h2 id="shipping-info">Shipping Information</h2>
                <p>
                  We currently ship orders <strong>within the United States only</strong>, using reliable and cost-effective shipping methods such as USPS, Fedex, UPS, etc.
                </p>
                <p>
                  Shipping rates are calculated at checkout based on the weight of your order and USPS rate policies, including applicable shipping insurance. Weight is rounded up to the nearest full pound as per USPS guidelines.
                </p>
                <p>
                  After your order has been placed, we will add the tracking information to your order once it has been shipped and a tracking number has been obtained.
                </p>
              </section>

              <section aria-labelledby="returns-guarantee">
                <h2 id="returns-guarantee">Returns and Guarantee</h2>
                <p>
                  For any questions or inquiries regarding returns, repairs, or refunds, please <Link to="/contact">contact us</Link> directly.
                </p>
              </section>

              <section aria-labelledby="return-instructions">
                <h2 id="return-instructions">Return Instructions</h2>
                <p>
                  To return your item, please contact us.
                </p>
                <p>
                  Customers are responsible for return shipping costs.
                </p>
                <p>
                  We recommend purchasing insurance for returns with a significant value. We are not responsible for items lost or damaged in return transit.
                </p>
              </section>

              <section aria-labelledby="refunds">
                <h2 id="refunds">Refunds</h2>
                <p>
                  Once your return is received and inspected, we will notify you whether your refund has been approved. Approved refunds are issued to the original payment method.
                </p>
                <h3>Late or Missing Refunds</h3>
                <ul>
                  <li>Double-check your bank account.</li>
                  <li>Contact your credit card provider — it may take additional time before your refund posts.</li>
                  <li>Contact your bank — processing times may vary.</li>
                </ul>
                <p>
                  If you have completed these steps and still have not received your refund, please email us at <a href="mailto:contact@withrowknives.com">contact@withrowknives.com</a>.
                </p>
              </section>

              <section aria-labelledby="shipping-questions">
                <h2 id="shipping-questions">Questions?</h2>
                <p>If you have any questions regarding shipping, returns, etc., don’t hesitate to contact us:</p>
                <div className="terms-contact">
                  <strong>Email:</strong> <a href={`mailto:${config.contactEmail}`}>{config.contactEmail}</a><br />
                  Or <Link to="/contact">click here</Link> to submit a contact form.
                </div>
              </section>
            </div>
          </div>


    </>
  );
};

export default ShippingAndReturns;